/**
 * AUTO-GENERATED by scripts/generate-frost-normals.mjs. Do not edit by hand.
 *
 * NOAA NCEI 1991-2020 Climate Normals, median (50% probability) first fall
 * minimum at or below 32°F and 28°F, per 3-digit ZIP prefix. Rows are
 * [zip3, lat, lon, first32Doy, first28Doy]. Day of year is non-leap; a value
 * above 365 falls in January-June of the next year; 0 means no fall frost in
 * the median year. 896 prefixes from 7305 stations.
 */

export const FROST_NORMALS_ZIP3: ReadonlyArray<readonly [number, number, number, number, number]> = [
  [6, 18.27, -66.84, 0, 0],
  [7, 18.16, -66.11, 0, 0],
  [8, 17.94, -64.8, 0, 0],
  [9, 18.41, -66.09, 0, 0],
  [10, 42.27, -72.57, 283, 296],
  [11, 42.11, -72.55, 286, 298],
  [12, 42.34, -73.23, 278, 290],
  [13, 42.59, -72.57, 282, 295],
  [14, 42.59, -71.79, 282, 294],
  [15, 42.22, -71.83, 286, 298],
  [16, 42.27, -71.83, 289, 300],
  [17, 42.35, -71.45, 283, 295],
  [18, 42.64, -71.21, 287, 300],
  [19, 42.61, -70.9, 288, 301],
  [20, 42.15, -71.14, 288, 300],
  [21, 42.34, -71.07, 302, 313],
  [22, 42.35, -71.06, 306, 318],
  [23, 42.02, -70.91, 292, 305],
  [24, 42.35, -71.22, 288, 301],
  [25, 41.59, -70.54, 299, 312],
  [26, 41.73, -70.18, 305, 317],
  [27, 41.75, -71.08, 294, 306],
  [28, 41.68, -71.53, 292, 304],
  [29, 41.82, -71.43, 297, 308],
  [30, 42.88, -71.51, 282, 293],
  [31, 42.99, -71.46, 286, 299],
  [32, 43.52, -71.66, 276, 287],
  [33, 43.25, -71.55, 275, 285],
  [34, 42.92, -72.21, 277, 289],
  [35, 44.49, -71.46, 268, 279],
  [36, 43.18, -72.34, 275, 287],
  [37, 43.72, -72.12, 276, 287],
  [38, 43.41, -71.07, 279, 292],
  [39, 43.19, -70.7, 284, 298],
  [40, 43.75, -70.53, 279, 289],
  [41, 43.67, -70.25, 289, 302],
  [42, 44.33, -70.4, 277, 290],
  [43, 44.29, -69.77, 286, 300],
  [44, 45.15, -68.71, 276, 289],
  [45, 43.94, -69.57, 289, 303],
  [46, 44.53, -68, 288, 300],
  [47, 46.66, -68.27, 268, 279],
  [48, 44.09, -69.11, 294, 306],
  [49, 44.78, -69.67, 276, 288],
  [50, 43.83, -72.39, 275, 285],
  [51, 43.27, -72.63, 275, 285],
  [52, 43.04, -73.12, 274, 284],
  [53, 42.94, -72.79, 276, 287],
  [54, 44.61, -73.05, 283, 295],
  [56, 44.33, -72.56, 272, 283],
  [57, 43.65, -73.05, 273, 283],
  [58, 44.69, -72.14, 272, 282],
  [59, 44.78, -71.67, 266, 277],
  [60, 41.87, -72.82, 288, 300],
  [61, 41.75, -72.69, 296, 307],
  [62, 41.81, -72.1, 289, 301],
  [63, 41.5, -72.03, 301, 313],
  [64, 41.44, -72.74, 295, 307],
  [65, 41.34, -72.94, 297, 308],
  [66, 41.2, -73.19, 305, 317],
  [67, 41.65, -73.2, 286, 299],
  [68, 41.19, -73.45, 300, 311],
  [69, 41.09, -73.54, 301, 312],
  [70, 40.76, -74.23, 304, 315],
  [71, 40.75, -74.19, 310, 322],
  [72, 40.67, -74.22, 310, 323],
  [73, 40.72, -74.05, 315, 327],
  [74, 41.04, -74.3, 296, 308],
  [75, 40.92, -74.17, 303, 314],
  [76, 40.93, -74.02, 309, 321],
  [77, 40.32, -74.1, 303, 315],
  [78, 40.93, -74.76, 291, 303],
  [79, 40.74, -74.52, 297, 308],
  [80, 39.82, -74.98, 306, 318],
  [81, 39.93, -75.09, 310, 321],
  [82, 39.27, -74.67, 310, 324],
  [83, 39.43, -75.03, 299, 309],
  [84, 39.34, -74.5, 324, 336],
  [85, 40.26, -74.64, 296, 307],
  [86, 40.2, -74.7, 299, 310],
  [87, 39.99, -74.16, 297, 309],
  [88, 40.54, -74.62, 295, 307],
  [89, 40.48, -74.45, 300, 311],
  [100, 40.77, -73.97, 323, 334],
  [101, 40.76, -73.97, 323, 334],
  [102, 40.71, -74.01, 321, 333],
  [103, 40.59, -74.15, 314, 326],
  [104, 40.85, -73.88, 323, 335],
  [105, 41.2, -73.77, 295, 308],
  [106, 41.04, -73.77, 302, 314],
  [107, 40.95, -73.85, 306, 318],
  [108, 40.91, -73.78, 316, 328],
  [109, 41.26, -74.16, 295, 307],
  [110, 40.75, -73.71, 320, 332],
  [111, 40.76, -73.93, 325, 336],
  [112, 40.65, -73.96, 323, 334],
  [113, 40.75, -73.83, 325, 336],
  [114, 40.7, -73.79, 321, 333],
  [115, 40.71, -73.64, 315, 328],
  [116, 40.58, -73.83, 318, 330],
  [117, 40.8, -73.23, 311, 324],
  [118, 40.77, -73.48, 313, 325],
  [119, 40.93, -72.55, 301, 313],
  [120, 42.69, -73.95, 282, 295],
  [121, 42.69, -73.94, 286, 299],
  [122, 42.67, -73.79, 291, 304],
  [123, 42.81, -73.94, 289, 301],
  [124, 42.09, -74.21, 279, 290],
  [125, 41.79, -73.84, 288, 300],
  [126, 41.69, -73.89, 290, 302],
  [127, 41.69, -74.76, 280, 294],
  [128, 43.49, -73.73, 277, 288],
  [129, 44.55, -73.92, 278, 291],
  [130, 42.97, -76.19, 286, 301],
  [131, 43.07, -76.26, 288, 302],
  [132, 43.05, -76.15, 289, 303],
  [133, 43.17, -75.21, 279, 293],
  [134, 43.1, -75.24, 281, 294],
  [135, 43.11, -75.19, 286, 300],
  [136, 44.3, -75.52, 277, 289],
  [137, 42.26, -75.45, 279, 292],
  [138, 42.37, -75.53, 279, 292],
  [139, 42.12, -75.9, 285, 300],
  [140, 42.79, -78.63, 289, 303],
  [141, 42.8, -78.71, 291, 304],
  [142, 42.92, -78.83, 295, 307],
  [143, 43.1, -79.02, 294, 306],
  [144, 42.95, -77.61, 291, 305],
  [145, 42.93, -77.51, 290, 305],
  [146, 43.17, -77.62, 295, 309],
  [147, 42.2, -78.87, 283, 296],
  [148, 42.3, -77.14, 280, 294],
  [149, 42.09, -76.82, 283, 297],
  [150, 40.46, -80.07, 301, 312],
  [151, 40.42, -79.93, 302, 314],
  [152, 40.45, -79.98, 304, 315],
  [153, 40.03, -80.17, 296, 306],
  [154, 39.96, -79.76, 295, 305],
  [155, 39.97, -78.89, 286, 298],
  [156, 40.32, -79.54, 291, 302],
  [157, 40.72, -79.03, 286, 299],
  [158, 41.26, -78.71, 285, 299],
  [159, 40.36, -78.85, 287, 299],
  [160, 40.92, -79.89, 289, 302],
  [161, 41.17, -80.35, 289, 301],
  [162, 41, -79.38, 286, 299],
  [163, 41.55, -79.57, 291, 302],
  [164, 41.89, -80.05, 293, 307],
  [165, 42.11, -80.06, 302, 314],
  [166, 40.46, -78.34, 291, 303],
  [167, 41.81, -78.48, 277, 290],
  [168, 40.95, -77.98, 283, 296],
  [169, 41.83, -77.28, 280, 293],
  [170, 40.41, -77.06, 296, 309],
  [171, 40.28, -76.85, 300, 312],
  [172, 40.02, -77.77, 298, 310],
  [173, 39.9, -76.85, 296, 307],
  [174, 39.95, -76.72, 293, 305],
  [175, 40.04, -76.24, 301, 312],
  [176, 40.06, -76.3, 300, 311],
  [177, 41.3, -77.12, 293, 305],
  [178, 40.89, -76.79, 291, 303],
  [179, 40.71, -76.28, 295, 306],
  [180, 40.64, -75.47, 294, 306],
  [181, 40.6, -75.52, 294, 306],
  [182, 40.91, -75.95, 292, 303],
  [183, 41.09, -75.23, 285, 297],
  [184, 41.57, -75.39, 280, 292],
  [185, 41.41, -75.67, 288, 302],
  [186, 41.32, -76.06, 285, 298],
  [187, 41.24, -75.88, 286, 300],
  [188, 41.82, -76.1, 281, 295],
  [189, 40.35, -75.16, 297, 309],
  [190, 40.01, -75.22, 312, 324],
  [191, 40, -75.15, 315, 327],
  [193, 39.94, -75.73, 299, 310],
  [194, 40.19, -75.42, 299, 309],
  [195, 40.42, -75.9, 298, 309],
  [196, 40.34, -75.95, 300, 311],
  [197, 39.65, -75.65, 306, 318],
  [198, 39.76, -75.57, 309, 321],
  [199, 38.85, -75.44, 308, 320],
  [200, 38.91, -77.03, 313, 325],
  [201, 38.92, -77.6, 300, 310],
  [202, 38.89, -77.03, 314, 327],
  [203, 38.88, -77.01, 316, 329],
  [204, 38.9, -77.04, 314, 326],
  [205, 38.9, -77.03, 314, 327],
  [206, 38.39, -76.72, 314, 326],
  [207, 38.92, -76.8, 307, 318],
  [208, 39.11, -77.16, 307, 318],
  [209, 39.04, -77.01, 309, 320],
  [210, 39.36, -76.56, 309, 321],
  [211, 39.42, -76.64, 310, 322],
  [212, 39.32, -76.6, 315, 328],
  [214, 38.99, -76.5, 320, 334],
  [215, 39.58, -79.01, 291, 302],
  [216, 38.85, -76.05, 311, 324],
  [217, 39.48, -77.49, 301, 313],
  [218, 38.27, -75.62, 310, 323],
  [219, 39.56, -75.97, 305, 316],
  [220, 38.81, -77.26, 307, 318],
  [221, 38.77, -77.28, 306, 317],
  [222, 38.88, -77.1, 313, 325],
  [223, 38.79, -77.1, 315, 327],
  [224, 38.06, -76.97, 305, 316],
  [225, 38.05, -77.12, 304, 315],
  [226, 39.02, -78.23, 297, 308],
  [227, 38.47, -78.06, 298, 308],
  [228, 38.58, -78.82, 294, 303],
  [229, 38.02, -78.59, 300, 310],
  [230, 37.6, -77.16, 305, 315],
  [231, 37.58, -77.12, 306, 316],
  [232, 37.55, -77.48, 306, 316],
  [233, 37.4, -75.93, 315, 328],
  [234, 37.3, -75.99, 316, 329],
  [235, 36.89, -76.27, 325, 340],
  [236, 37.09, -76.43, 319, 332],
  [237, 36.83, -76.33, 325, 340],
  [238, 36.96, -77.41, 306, 316],
  [239, 37.01, -78.4, 304, 314],
  [240, 37.14, -80.09, 299, 309],
  [241, 37.09, -80.16, 297, 306],
  [242, 36.86, -82.47, 295, 304],
  [243, 36.84, -81.14, 292, 301],
  [244, 38.08, -79.36, 292, 303],
  [245, 37.15, -79.13, 300, 309],
  [246, 37.21, -81.78, 291, 300],
  [247, 37.41, -81.23, 291, 300],
  [248, 37.47, -81.64, 297, 306],
  [249, 37.86, -80.42, 286, 296],
  [250, 38.19, -81.48, 300, 309],
  [251, 38.23, -81.52, 299, 309],
  [252, 38.61, -81.56, 294, 303],
  [253, 38.36, -81.63, 297, 307],
  [254, 39.41, -78.07, 295, 305],
  [255, 38.29, -82.16, 299, 308],
  [256, 37.76, -82.03, 304, 313],
  [257, 38.39, -82.4, 303, 312],
  [258, 37.79, -81.22, 291, 301],
  [259, 37.78, -81.06, 291, 301],
  [260, 40.17, -80.62, 299, 309],
  [261, 39.21, -81.25, 293, 303],
  [262, 38.75, -80.05, 286, 297],
  [263, 39.2, -80.53, 296, 306],
  [264, 39.25, -80.38, 294, 304],
  [265, 39.58, -80.11, 296, 305],
  [266, 38.46, -80.81, 293, 302],
  [267, 39.34, -78.98, 289, 300],
  [268, 38.96, -79.01, 288, 299],
  [270, 36.25, -80.4, 301, 310],
  [271, 36.09, -80.26, 308, 320],
  [272, 35.88, -79.67, 308, 320],
  [273, 35.93, -79.62, 308, 319],
  [274, 36.08, -79.82, 308, 319],
  [275, 35.89, -78.57, 309, 320],
  [276, 35.82, -78.65, 311, 324],
  [277, 35.99, -78.9, 308, 320],
  [278, 35.92, -77.41, 312, 326],
  [279, 36.09, -76.19, 319, 334],
  [280, 35.37, -81.04, 305, 316],
  [281, 35.29, -80.76, 307, 317],
  [282, 35.21, -80.83, 309, 320],
  [283, 34.98, -78.97, 312, 324],
  [284, 34.32, -78.23, 316, 329],
  [285, 35, -77.09, 318, 331],
  [286, 36.09, -81.37, 298, 307],
  [287, 35.45, -82.72, 297, 306],
  [288, 35.59, -82.55, 300, 309],
  [289, 35.09, -83.91, 294, 304],
  [290, 33.96, -80.81, 313, 327],
  [291, 33.88, -80.89, 314, 328],
  [292, 34.03, -81, 320, 335],
  [293, 34.85, -81.91, 305, 315],
  [294, 32.96, -80.13, 332, 349],
  [295, 34.08, -79.42, 315, 328],
  [296, 34.68, -82.58, 310, 323],
  [297, 34.86, -80.94, 308, 320],
  [298, 33.54, -81.79, 313, 327],
  [299, 32.54, -80.94, 330, 350],
  [300, 33.87, -84.16, 312, 325],
  [301, 34.02, -84.85, 308, 319],
  [302, 33.32, -84.46, 315, 329],
  [303, 33.8, -84.38, 315, 328],
  [304, 32.43, -82.13, 324, 340],
  [305, 34.53, -83.72, 308, 320],
  [306, 33.88, -83.24, 312, 326],
  [307, 34.77, -85.11, 307, 318],
  [308, 33.34, -82.35, 315, 330],
  [309, 33.45, -82.03, 327, 346],
  [310, 32.59, -83.46, 318, 333],
  [312, 32.84, -83.66, 319, 333],
  [313, 31.95, -81.42, 332, 351],
  [314, 32.05, -81.12, 335, 356],
  [315, 31.34, -82.13, 324, 340],
  [316, 30.99, -83.2, 326, 344],
  [317, 31.47, -83.85, 325, 341],
  [318, 32.52, -84.72, 314, 327],
  [319, 32.47, -84.94, 320, 335],
  [320, 30.16, -82.22, 339, 361],
  [321, 29.3, -81.47, 370, 377],
  [322, 30.3, -81.63, 364, 375],
  [323, 30.32, -84.26, 328, 345],
  [324, 30.51, -85.54, 331, 352],
  [325, 30.55, -86.99, 337, 356],
  [326, 29.59, -82.48, 335, 356],
  [327, 28.78, -81.32, 373, 376],
  [328, 28.51, -81.32, 376, 0],
  [329, 28.04, -80.62, 377, 0],
  [330, 25.77, -80.41, 0, 0],
  [331, 25.77, -80.28, 0, 0],
  [333, 26.13, -80.24, 0, 0],
  [334, 26.62, -80.2, 380, 0],
  [335, 28.12, -82.26, 373, 371],
  [336, 28, -82.48, 377, 0],
  [337, 27.86, -82.73, 379, 0],
  [338, 27.89, -81.69, 373, 0],
  [339, 26.7, -81.89, 379, 0],
  [341, 26.13, -81.64, 0, 0],
  [342, 27.3, -82.41, 375, 0],
  [344, 29.01, -82.33, 348, 368],
  [346, 28.31, -82.61, 361, 370],
  [347, 28.48, -81.59, 373, 375],
  [349, 27.32, -80.41, 378, 0],
  [350, 33.57, -86.71, 310, 321],
  [351, 33.51, -86.63, 311, 323],
  [352, 33.5, -86.8, 313, 325],
  [354, 33.11, -87.79, 316, 330],
  [355, 33.97, -87.66, 308, 319],
  [356, 34.69, -87.31, 308, 319],
  [357, 34.74, -86.34, 305, 315],
  [358, 34.71, -86.61, 308, 318],
  [359, 34.29, -85.94, 308, 320],
  [360, 32.15, -86.17, 318, 331],
  [361, 32.37, -86.28, 318, 332],
  [362, 33.54, -85.7, 307, 317],
  [363, 31.3, -85.54, 327, 344],
  [364, 31.42, -87.05, 320, 334],
  [365, 30.89, -87.95, 326, 341],
  [366, 30.69, -88.13, 333, 353],
  [367, 32.3, -87.37, 316, 329],
  [368, 32.58, -85.35, 315, 328],
  [369, 32.15, -88.24, 316, 329],
  [370, 36.12, -86.86, 301, 311],
  [371, 36.08, -86.76, 301, 310],
  [372, 36.15, -86.79, 305, 314],
  [373, 35.26, -85.35, 303, 313],
  [374, 35.05, -85.28, 310, 321],
  [376, 36.37, -82.34, 297, 305],
  [377, 36.14, -83.9, 300, 309],
  [378, 36.1, -83.81, 300, 309],
  [379, 35.97, -83.98, 303, 312],
  [380, 35.52, -89.44, 308, 320],
  [381, 35.12, -89.94, 315, 327],
  [382, 36.28, -88.72, 304, 313],
  [383, 35.6, -88.51, 303, 312],
  [384, 35.29, -87.31, 302, 312],
  [385, 36.19, -85.42, 298, 308],
  [386, 34.59, -89.79, 309, 321],
  [387, 33.58, -90.81, 318, 332],
  [388, 34.32, -88.63, 308, 319],
  [389, 33.79, -89.94, 311, 324],
  [390, 32.48, -90.17, 317, 331],
  [391, 32.39, -90.2, 317, 331],
  [392, 32.31, -90.19, 320, 334],
  [393, 32.37, -88.82, 315, 328],
  [394, 31.35, -89.3, 319, 333],
  [395, 30.45, -89.02, 333, 351],
  [396, 31.34, -90.56, 317, 332],
  [397, 33.53, -88.88, 311, 323],
  [398, 31.34, -84.66, 322, 338],
  [400, 38.12, -85.32, 295, 305],
  [401, 37.87, -86.16, 296, 305],
  [402, 38.21, -85.69, 309, 319],
  [403, 38.06, -84.2, 296, 307],
  [404, 37.49, -84.42, 299, 308],
  [405, 38.03, -84.49, 301, 310],
  [406, 38.23, -84.87, 296, 306],
  [407, 36.94, -84.08, 296, 305],
  [408, 36.9, -83.27, 299, 307],
  [409, 36.93, -83.69, 296, 304],
  [410, 38.79, -84.44, 299, 309],
  [411, 38.37, -82.96, 296, 306],
  [412, 37.86, -82.72, 296, 304],
  [413, 37.57, -83.46, 297, 307],
  [414, 37.83, -83.2, 295, 305],
  [415, 37.46, -82.35, 300, 309],
  [416, 37.5, -82.74, 296, 305],
  [417, 37.24, -83.22, 299, 307],
  [418, 37.22, -82.86, 296, 305],
  [420, 36.9, -88.58, 302, 312],
  [421, 36.88, -86.03, 302, 310],
  [422, 36.94, -86.99, 302, 312],
  [423, 37.46, -87.02, 299, 308],
  [424, 37.48, -87.65, 302, 311],
  [425, 37.15, -84.72, 300, 309],
  [426, 36.78, -84.7, 296, 306],
  [427, 37.34, -85.76, 296, 306],
  [430, 40.17, -82.93, 293, 304],
  [431, 39.69, -82.9, 294, 304],
  [432, 39.99, -82.98, 297, 307],
  [433, 40.52, -83.38, 294, 305],
  [434, 41.46, -83.29, 298, 309],
  [435, 41.46, -84.14, 294, 305],
  [436, 41.66, -83.57, 298, 309],
  [437, 39.86, -81.71, 292, 303],
  [438, 40.26, -81.87, 293, 304],
  [439, 40.22, -80.85, 298, 308],
  [440, 41.53, -81.4, 299, 310],
  [441, 41.46, -81.67, 310, 320],
  [442, 41.11, -81.59, 297, 308],
  [443, 41.07, -81.53, 298, 309],
  [444, 41.09, -80.75, 291, 304],
  [445, 41.09, -80.66, 290, 304],
  [446, 40.67, -81.47, 290, 302],
  [447, 40.82, -81.38, 299, 310],
  [448, 41.03, -82.77, 295, 306],
  [449, 40.75, -82.53, 291, 303],
  [450, 39.39, -84.48, 294, 303],
  [451, 39.1, -83.92, 294, 305],
  [452, 39.17, -84.49, 297, 307],
  [453, 39.99, -84.28, 294, 305],
  [454, 39.75, -84.17, 298, 308],
  [455, 39.94, -83.82, 292, 303],
  [456, 38.94, -82.82, 295, 305],
  [457, 39.34, -81.8, 294, 304],
  [458, 40.82, -84.19, 296, 306],
  [460, 40.15, -86.05, 294, 305],
  [461, 39.65, -86.17, 295, 305],
  [462, 39.81, -86.14, 298, 308],
  [463, 41.44, -87.16, 294, 305],
  [464, 41.57, -87.33, 299, 310],
  [465, 41.45, -86.06, 293, 304],
  [466, 41.68, -86.26, 294, 305],
  [467, 41.19, -85.2, 291, 303],
  [468, 41.08, -85.15, 293, 304],
  [469, 40.73, -86.07, 292, 304],
  [470, 39.17, -85.07, 294, 304],
  [471, 38.39, -86.01, 299, 309],
  [472, 39.06, -85.73, 296, 306],
  [473, 40.06, -85.21, 292, 302],
  [474, 39.04, -86.68, 297, 306],
  [475, 38.42, -87, 300, 309],
  [476, 38.16, -87.47, 301, 311],
  [477, 38, -87.56, 307, 317],
  [478, 39.46, -87.32, 293, 304],
  [479, 40.43, -87.07, 290, 301],
  [480, 42.68, -82.91, 296, 307],
  [481, 42.21, -83.5, 292, 304],
  [482, 42.37, -83.1, 298, 309],
  [483, 42.63, -83.33, 290, 303],
  [484, 43.25, -83.28, 286, 300],
  [485, 43.02, -83.68, 283, 296],
  [486, 43.86, -84.3, 282, 295],
  [487, 43.94, -83.57, 284, 298],
  [488, 43.03, -84.69, 286, 300],
  [489, 42.73, -84.57, 288, 301],
  [490, 42.21, -85.58, 290, 303],
  [491, 41.89, -86.43, 296, 308],
  [492, 42.04, -84.33, 286, 300],
  [493, 43.26, -85.54, 279, 290],
  [494, 43.26, -86.14, 287, 300],
  [495, 42.94, -85.66, 287, 300],
  [496, 44.53, -85.64, 282, 297],
  [497, 45.58, -84.52, 276, 289],
  [498, 46.08, -87.19, 274, 286],
  [499, 46.75, -88.82, 270, 283],
  [500, 41.67, -93.77, 284, 295],
  [501, 41.61, -93.47, 284, 295],
  [502, 41.67, -93.57, 284, 295],
  [503, 41.6, -93.65, 291, 301],
  [504, 43.16, -93.36, 279, 290],
  [505, 42.75, -94.46, 281, 292],
  [506, 42.63, -92.46, 281, 292],
  [507, 42.48, -92.31, 282, 292],
  [508, 40.96, -94.55, 285, 297],
  [510, 42.6, -95.91, 278, 289],
  [511, 42.51, -96.39, 279, 289],
  [512, 43.27, -96.04, 276, 286],
  [513, 43.26, -95.13, 277, 289],
  [514, 42.1, -95.06, 281, 293],
  [515, 41.46, -95.56, 283, 294],
  [516, 40.73, -95.36, 289, 299],
  [520, 42.48, -90.97, 286, 296],
  [521, 43.15, -91.73, 278, 288],
  [522, 41.9, -91.75, 283, 293],
  [523, 41.91, -91.73, 283, 294],
  [524, 41.99, -91.67, 285, 295],
  [525, 40.97, -92.43, 289, 299],
  [526, 40.87, -91.44, 292, 302],
  [527, 41.65, -90.78, 291, 300],
  [528, 41.55, -90.6, 292, 301],
  [530, 43.46, -88.23, 286, 298],
  [531, 42.76, -88.24, 288, 299],
  [532, 43.05, -87.97, 295, 305],
  [534, 42.74, -87.83, 297, 308],
  [535, 42.95, -89.62, 283, 294],
  [537, 43.07, -89.4, 284, 295],
  [538, 42.84, -90.75, 288, 298],
  [539, 43.61, -89.52, 279, 291],
  [540, 45.08, -92.49, 277, 288],
  [541, 44.87, -88.25, 278, 290],
  [542, 44.57, -87.56, 289, 303],
  [543, 44.51, -88.02, 283, 298],
  [544, 44.88, -89.78, 275, 285],
  [545, 45.92, -89.9, 270, 280],
  [546, 43.86, -90.93, 279, 290],
  [547, 44.84, -91.58, 276, 287],
  [548, 46.03, -91.64, 273, 284],
  [549, 44.21, -88.85, 280, 291],
  [550, 45.04, -93.02, 278, 289],
  [551, 44.95, -93.1, 287, 298],
  [553, 44.97, -93.89, 281, 292],
  [554, 44.98, -93.31, 286, 298],
  [556, 47.56, -91.05, 273, 283],
  [557, 47.18, -92.78, 267, 278],
  [558, 46.81, -92.13, 281, 294],
  [559, 43.9, -92.31, 276, 286],
  [560, 44, -93.96, 280, 290],
  [561, 43.9, -95.66, 277, 288],
  [562, 45.02, -95.66, 277, 288],
  [563, 45.77, -94.66, 275, 285],
  [564, 46.56, -94.51, 274, 285],
  [565, 46.84, -96.13, 274, 285],
  [566, 47.82, -94.44, 269, 280],
  [567, 48.39, -96.33, 272, 280],
  [570, 43.49, -97.02, 277, 287],
  [571, 43.54, -96.74, 282, 293],
  [572, 45.03, -97.12, 275, 285],
  [573, 43.79, -98.4, 277, 286],
  [574, 45.35, -98.76, 273, 281],
  [575, 43.76, -100.44, 275, 285],
  [576, 45.52, -101.38, 273, 280],
  [577, 44.11, -103.07, 272, 281],
  [580, 46.68, -97.31, 274, 283],
  [581, 46.87, -96.82, 275, 285],
  [582, 48.22, -97.65, 272, 281],
  [583, 48.37, -99.21, 269, 277],
  [584, 46.95, -99.01, 271, 279],
  [585, 46.78, -100.92, 271, 279],
  [586, 46.79, -102.93, 266, 275],
  [587, 48.35, -101.57, 268, 276],
  [588, 48.26, -103.49, 266, 274],
  [590, 45.8, -108.71, 264, 274],
  [591, 45.77, -108.53, 277, 287],
  [592, 48.33, -105.32, 262, 270],
  [593, 46.3, -105.43, 267, 276],
  [594, 47.74, -111.22, 262, 273],
  [595, 48.49, -109.43, 265, 273],
  [596, 46.56, -111.93, 258, 270],
  [597, 45.66, -112.22, 254, 268],
  [598, 47.03, -114.29, 268, 280],
  [599, 48.31, -114.45, 268, 281],
  [600, 42.24, -88.01, 295, 306],
  [601, 41.97, -88.24, 290, 301],
  [602, 42.05, -87.69, 299, 310],
  [603, 41.89, -87.8, 305, 315],
  [604, 41.52, -87.92, 297, 307],
  [605, 41.73, -88.31, 292, 302],
  [606, 41.87, -87.67, 306, 316],
  [607, 41.98, -87.79, 299, 309],
  [608, 41.72, -87.71, 303, 313],
  [609, 40.82, -87.94, 291, 302],
  [610, 42.21, -89.52, 286, 297],
  [611, 42.29, -89.05, 287, 298],
  [612, 41.49, -90.35, 292, 302],
  [613, 41.35, -89.21, 292, 302],
  [614, 40.84, -90.42, 292, 301],
  [615, 40.69, -89.7, 293, 302],
  [616, 40.7, -89.61, 294, 304],
  [617, 40.5, -88.92, 291, 301],
  [618, 40.1, -88.12, 292, 302],
  [619, 39.68, -88.22, 295, 306],
  [620, 39.06, -89.98, 298, 309],
  [622, 38.43, -89.8, 298, 308],
  [623, 40.02, -91.05, 296, 306],
  [624, 39.04, -88.21, 295, 305],
  [625, 39.7, -89.23, 295, 305],
  [626, 39.83, -89.99, 293, 303],
  [627, 39.79, -89.65, 294, 304],
  [628, 38.32, -88.68, 298, 307],
  [629, 37.56, -88.98, 298, 308],
  [630, 38.44, -90.68, 298, 308],
  [631, 38.64, -90.3, 305, 315],
  [633, 38.97, -91.03, 297, 307],
  [634, 39.95, -91.76, 296, 306],
  [635, 40.2, -92.59, 291, 301],
  [636, 37.67, -90.64, 295, 305],
  [637, 37.3, -89.78, 299, 308],
  [638, 36.5, -89.79, 308, 321],
  [639, 36.86, -90.52, 304, 313],
  [640, 39.08, -94.21, 298, 307],
  [641, 39.11, -94.55, 303, 312],
  [644, 40.11, -94.69, 292, 302],
  [645, 39.76, -94.83, 291, 300],
  [646, 39.88, -93.56, 294, 303],
  [647, 38.1, -94.2, 299, 308],
  [648, 36.96, -94.35, 299, 308],
  [650, 38.45, -92.27, 301, 310],
  [651, 38.54, -92.21, 301, 310],
  [652, 39.21, -92.39, 298, 308],
  [653, 38.75, -93.24, 297, 307],
  [654, 37.67, -91.82, 295, 305],
  [655, 37.65, -91.93, 295, 305],
  [656, 37.05, -93.11, 298, 307],
  [657, 37.06, -93.01, 298, 307],
  [658, 37.19, -93.29, 300, 309],
  [660, 38.92, -95.12, 296, 305],
  [661, 39.11, -94.68, 303, 312],
  [662, 38.96, -94.71, 301, 309],
  [664, 39.39, -96.05, 292, 301],
  [665, 39.33, -96.09, 292, 301],
  [666, 39.04, -95.71, 295, 304],
  [667, 37.61, -95.09, 301, 309],
  [668, 38.36, -96.38, 295, 305],
  [669, 39.79, -97.72, 289, 297],
  [670, 37.56, -97.6, 298, 306],
  [671, 37.54, -97.67, 298, 306],
  [672, 37.69, -97.32, 300, 309],
  [673, 37.19, -95.76, 301, 308],
  [674, 38.94, -97.75, 292, 302],
  [675, 38.24, -98.87, 293, 302],
  [676, 39.32, -99.41, 288, 297],
  [677, 39.34, -101.08, 284, 293],
  [678, 37.81, -100.67, 292, 301],
  [679, 37.17, -101.45, 295, 303],
  [680, 41.47, -96.42, 287, 297],
  [681, 41.24, -96.03, 292, 301],
  [683, 40.47, -96.83, 288, 296],
  [684, 40.54, -96.62, 287, 296],
  [685, 40.82, -96.68, 286, 295],
  [686, 41.49, -97.53, 283, 293],
  [687, 42.41, -97.74, 278, 289],
  [688, 41.16, -98.93, 281, 290],
  [689, 40.34, -98.82, 286, 295],
  [690, 40.34, -100.89, 281, 291],
  [691, 41.3, -101.58, 279, 288],
  [692, 42.69, -100.59, 277, 286],
  [693, 42.18, -103, 274, 283],
  [700, 29.86, -90.18, 358, 370],
  [701, 29.97, -90.06, 363, 372],
  [703, 29.66, -90.76, 351, 367],
  [704, 30.58, -90.24, 323, 337],
  [705, 30.23, -92.17, 336, 355],
  [706, 30.4, -93.16, 332, 350],
  [707, 30.52, -91.2, 332, 351],
  [708, 30.45, -91.12, 330, 346],
  [710, 32.49, -93.48, 319, 333],
  [711, 32.46, -93.76, 322, 336],
  [712, 32.56, -92, 318, 331],
  [713, 31.29, -91.97, 325, 340],
  [714, 31.56, -92.84, 324, 339],
  [716, 33.66, -91.73, 316, 330],
  [717, 33.53, -92.8, 310, 322],
  [718, 33.67, -93.85, 312, 323],
  [719, 34.37, -93.56, 309, 321],
  [720, 34.96, -91.98, 311, 322],
  [721, 34.91, -92.08, 311, 323],
  [722, 34.74, -92.37, 313, 324],
  [723, 35.06, -90.57, 314, 328],
  [724, 36.06, -90.74, 308, 319],
  [725, 36.01, -91.8, 302, 311],
  [726, 36.15, -92.88, 303, 314],
  [727, 36.15, -94.16, 301, 310],
  [728, 35.27, -93.39, 308, 320],
  [729, 35.33, -94.19, 306, 316],
  [730, 35.33, -97.75, 306, 315],
  [731, 35.47, -97.52, 308, 316],
  [734, 34.24, -97.18, 309, 318],
  [735, 34.52, -98.78, 310, 318],
  [736, 35.51, -99.29, 303, 311],
  [737, 36.38, -98.13, 304, 312],
  [738, 36.45, -99.5, 298, 306],
  [739, 36.74, -101.54, 296, 304],
  [740, 36.25, -96.21, 303, 312],
  [741, 36.13, -95.94, 307, 317],
  [743, 36.53, -94.98, 302, 311],
  [744, 35.64, -95.46, 305, 315],
  [745, 34.64, -95.7, 306, 316],
  [746, 36.7, -97.15, 300, 309],
  [747, 34.01, -95.59, 310, 322],
  [748, 35.18, -96.68, 307, 316],
  [749, 35.21, -94.7, 308, 319],
  [750, 33.06, -96.78, 322, 335],
  [751, 32.55, -96.43, 322, 334],
  [752, 32.81, -96.8, 329, 342],
  [753, 32.81, -96.84, 331, 345],
  [754, 33.37, -95.8, 318, 332],
  [755, 33.26, -94.38, 317, 331],
  [756, 32.45, -94.62, 321, 334],
  [757, 32.24, -95.34, 323, 336],
  [758, 31.47, -95.71, 321, 333],
  [759, 31.29, -94.36, 322, 336],
  [760, 32.65, -97.35, 321, 333],
  [761, 32.76, -97.33, 325, 337],
  [762, 33.42, -97.29, 317, 329],
  [763, 33.78, -98.76, 313, 322],
  [764, 32.54, -98.5, 312, 322],
  [765, 31.09, -97.55, 323, 335],
  [766, 31.75, -97.03, 320, 332],
  [767, 31.55, -97.15, 322, 335],
  [768, 31.31, -99.31, 316, 327],
  [769, 31.36, -100.6, 312, 323],
  [770, 29.78, -95.42, 352, 368],
  [772, 29.72, -95.34, 360, 371],
  [773, 30.35, -95.32, 331, 348],
  [774, 29.45, -95.97, 342, 362],
  [775, 29.61, -95.03, 354, 369],
  [776, 30.1, -94.16, 336, 359],
  [777, 30.07, -94.16, 338, 363],
  [778, 30.66, -96.31, 326, 341],
  [779, 28.88, -96.91, 342, 362],
  [780, 28.97, -98.89, 335, 350],
  [781, 29.16, -97.98, 334, 350],
  [782, 29.47, -98.52, 335, 351],
  [783, 27.7, -97.88, 350, 363],
  [784, 27.74, -97.43, 359, 365],
  [785, 26.3, -98.08, 364, 0],
  [786, 30.25, -97.94, 326, 339],
  [787, 30.3, -97.77, 327, 343],
  [788, 29.33, -100.08, 328, 341],
  [789, 29.91, -96.82, 328, 342],
  [790, 35.34, -101.56, 298, 307],
  [791, 35.19, -101.85, 299, 308],
  [792, 34.27, -100.64, 307, 316],
  [793, 33.5, -102.19, 308, 317],
  [794, 33.56, -101.89, 311, 320],
  [795, 32.66, -100.18, 312, 322],
  [796, 32.42, -99.77, 311, 323],
  [797, 31.71, -102.51, 315, 325],
  [798, 30.77, -104.81, 314, 323],
  [799, 31.81, -106.4, 322, 333],
  [800, 39.8, -104.96, 281, 290],
  [801, 39.49, -104.78, 277, 286],
  [802, 39.75, -104.98, 282, 292],
  [803, 40.01, -105.26, 275, 284],
  [804, 39.83, -105.91, 253, 265],
  [805, 40.41, -105.16, 277, 285],
  [806, 40.34, -104.59, 278, 287],
  [807, 40.46, -103.07, 278, 287],
  [808, 39.08, -103.81, 277, 285],
  [809, 38.85, -104.73, 278, 287],
  [810, 37.88, -103.75, 283, 292],
  [811, 37.45, -106.19, 265, 273],
  [812, 38.52, -106.17, 260, 269],
  [813, 37.46, -108.45, 279, 288],
  [814, 38.4, -108.05, 281, 289],
  [815, 39.06, -108.64, 292, 303],
  [816, 39.69, -107.39, 266, 274],
  [820, 41.31, -105.13, 267, 276],
  [821, 44.52, -110.65, 0, 0],
  [822, 42.32, -104.55, 269, 278],
  [823, 41.69, -107.15, 260, 270],
  [824, 44.44, -108.41, 271, 280],
  [825, 43.1, -108.85, 268, 278],
  [826, 43.11, -106.63, 268, 277],
  [827, 44.38, -104.88, 266, 276],
  [828, 44.71, -106.87, 267, 276],
  [829, 41.76, -109.81, 260, 270],
  [830, 43.63, -110.7, 242, 256],
  [831, 42.54, -110.72, 0, 0],
  [832, 42.87, -112.36, 264, 276],
  [833, 42.81, -114.29, 275, 288],
  [834, 44.05, -112.13, 262, 274],
  [835, 46.15, -116.27, 280, 292],
  [836, 43.89, -116.3, 283, 296],
  [837, 43.64, -116.14, 292, 302],
  [838, 47.66, -116.53, 269, 282],
  [840, 40.63, -111.4, 278, 289],
  [841, 40.73, -111.89, 299, 310],
  [843, 41.7, -112.1, 277, 289],
  [844, 41.23, -111.98, 294, 305],
  [845, 38.73, -110.32, 282, 291],
  [846, 39.52, -111.86, 276, 287],
  [847, 37.83, -112.68, 277, 286],
  [850, 33.53, -112.08, 356, 0],
  [851, 33.01, -111.52, 337, 351],
  [852, 33.45, -111.8, 348, 358],
  [853, 33.46, -112.89, 351, 364],
  [855, 33.31, -110.3, 316, 328],
  [856, 31.86, -110.49, 315, 327],
  [857, 32.23, -110.96, 343, 357],
  [859, 34.21, -109.9, 283, 293],
  [860, 35.73, -111.18, 293, 303],
  [863, 34.67, -112.31, 304, 315],
  [864, 35.29, -114.12, 345, 319],
  [865, 36.05, -109.46, 284, 293],
  [870, 35.24, -106.78, 283, 292],
  [871, 35.11, -106.64, 298, 308],
  [873, 35.5, -108.6, 274, 282],
  [874, 36.68, -108.25, 284, 294],
  [875, 36.16, -105.89, 277, 287],
  [877, 36.03, -104.94, 274, 282],
  [878, 34.03, -107.79, 278, 288],
  [879, 32.96, -107.27, 307, 318],
  [880, 32.41, -107.6, 305, 315],
  [881, 34.23, -103.55, 298, 307],
  [882, 32.77, -103.9, 308, 317],
  [883, 33.25, -105.61, 291, 302],
  [884, 35.72, -103.79, 294, 304],
  [890, 36.59, -115.38, 330, 337],
  [891, 36.15, -115.22, 344, 357],
  [893, 39.29, -115.26, 263, 273],
  [894, 39.68, -119.06, 280, 293],
  [895, 39.57, -119.82, 294, 305],
  [897, 39.17, -119.78, 282, 296],
  [898, 41.11, -115.54, 257, 269],
  [900, 34.04, -118.31, 0, 0],
  [902, 33.95, -118.35, 0, 0],
  [903, 33.95, -118.35, 0, 0],
  [904, 34.02, -118.49, 0, 0],
  [905, 33.84, -118.33, 370, 0],
  [906, 33.92, -118.03, 0, 0],
  [907, 33.79, -118.18, 0, 0],
  [908, 33.79, -118.16, 0, 0],
  [910, 34.18, -118.12, 353, 0],
  [911, 34.15, -118.13, 364, 0],
  [912, 34.17, -118.25, 365, 0],
  [913, 34.27, -118.58, 361, 0],
  [914, 34.18, -118.46, 362, 0],
  [915, 34.19, -118.32, 361, 0],
  [916, 34.17, -118.38, 361, 0],
  [917, 34.08, -117.83, 361, 0],
  [918, 34.08, -118.14, 369, 0],
  [919, 32.7, -116.79, 318, 327],
  [920, 33.11, -117.08, 345, 0],
  [921, 32.77, -117.13, 0, 0],
  [922, 33.6, -115.91, 357, 340],
  [923, 34.48, -117.01, 323, 322],
  [924, 34.13, -117.3, 343, 0],
  [925, 33.76, -117.16, 360, 0],
  [926, 33.63, -117.78, 0, 0],
  [927, 33.74, -117.86, 0, 0],
  [928, 33.84, -117.82, 0, 0],
  [930, 34.26, -119.13, 344, 0],
  [931, 34.45, -119.78, 355, 0],
  [932, 35.86, -119.21, 333, 346],
  [933, 35.35, -119.03, 341, 353],
  [934, 35.22, -120.57, 350, 0],
  [935, 35.6, -118.15, 317, 330],
  [936, 36.83, -119.69, 332, 345],
  [937, 36.78, -119.79, 345, 356],
  [939, 36.48, -121.59, 343, 324],
  [940, 37.47, -122.27, 352, 349],
  [941, 37.76, -122.43, 0, 0],
  [943, 37.43, -122.15, 340, 356],
  [944, 37.55, -122.31, 353, 0],
  [945, 37.95, -122.06, 348, 354],
  [946, 37.8, -122.22, 0, 0],
  [947, 37.88, -122.27, 366, 0],
  [948, 37.95, -122.34, 364, 0],
  [949, 38.08, -122.68, 354, 0],
  [950, 37.08, -121.86, 339, 348],
  [951, 37.31, -121.85, 351, 0],
  [952, 38.12, -120.93, 339, 354],
  [953, 37.64, -120.67, 333, 347],
  [954, 38.88, -123.08, 327, 339],
  [955, 40.72, -123.89, 335, 354],
  [956, 38.65, -121.27, 337, 352],
  [957, 38.88, -120.9, 330, 348],
  [958, 38.58, -121.44, 341, 353],
  [959, 39.49, -121.52, 325, 341],
  [960, 40.88, -122.26, 289, 305],
  [961, 40.04, -120.29, 270, 285],
  [967, 20.39, -157.29, 0, 0],
  [968, 21.33, -157.85, 0, 0],
  [969, 13.81, 144.98, 0, 0],
  [970, 45.43, -122.23, 317, 336],
  [971, 45.54, -123.49, 306, 331],
  [972, 45.52, -122.66, 328, 347],
  [973, 44.74, -123.19, 307, 326],
  [974, 43.56, -123.41, 315, 337],
  [975, 42.39, -123.08, 293, 310],
  [976, 42.45, -121.21, 259, 273],
  [977, 43.84, -120.57, 255, 268],
  [978, 45.19, -118.59, 269, 281],
  [979, 43.85, -117.61, 276, 287],
  [980, 47.56, -122.12, 319, 335],
  [981, 47.59, -122.34, 323, 340],
  [982, 48.38, -122.29, 310, 328],
  [983, 47.45, -122.68, 313, 330],
  [984, 47.2, -122.47, 317, 335],
  [985, 46.94, -123.24, 302, 319],
  [986, 45.94, -122.46, 300, 318],
  [988, 47.89, -119.9, 285, 297],
  [989, 46.68, -120.54, 284, 296],
  [990, 47.62, -117.45, 271, 283],
  [991, 47.84, -118.01, 271, 283],
  [992, 47.68, -117.38, 283, 295],
  [993, 46.36, -118.96, 290, 302],
  [994, 46.23, -117.3, 286, 300],
  [995, 60.37, -153.51, 267, 277],
  [996, 59.94, -155.18, 265, 274],
  [997, 65.8, -152.98, 241, 252],
  [998, 57.88, -135.06, 287, 303],
  [999, 55.73, -132.22, 294, 313],
]
